import React, { useState } from 'react';
import { X, Target, Copy, CheckCircle } from 'lucide-react';

const EnrollmentSuccessModal = ({ 
  isOpen, 
  onClose, 
  course, 
  enrollmentCode,
  onGoToPortal 
}) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen || !course) return null;

  const handleGoToPortal = () => {
    onGoToPortal();
    onClose();
  };

  const handleCopyCode = () => {
    if (enrollmentCode) {
      navigator.clipboard.writeText(enrollmentCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1001
    }} onClick={onClose}>
      <div style={{
        backgroundColor: '#1a1a1a',
        borderRadius: '20px',
        padding: '40px',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '90vh',
        overflowY: 'auto',
        border: '1px solid #333',
        position: 'relative',
        textAlign: 'center'
      }} onClick={(e) => e.stopPropagation()}>
        <button 
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'transparent',
            border: 'none',
            color: '#9ca3af',
            cursor: 'pointer',
            padding: '8px'
          }}
          onClick={onClose}
        >
          <X size={20} />
        </button>

        {/* Success Icon */}
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: '#10b981',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
          animation: 'pulse 2s infinite'
        }}>
          <Target size={40} color="white" />
        </div>

        <h2 style={{
          color: 'white',
          fontSize: '24px',
          marginBottom: '16px',
          fontWeight: '600'
        }}>
          Enrollment Successful!
        </h2>

        <p style={{
          color: '#9ca3af',
          fontSize: '16px',
          marginBottom: '24px',
          lineHeight: '1.5'
        }}>
          You have successfully enrolled in <strong style={{ color: '#06b6d4' }}>{course.title}</strong>
        </p>

        {/* Enrollment Code */}
        {enrollmentCode && (
          <div style={{
            backgroundColor: '#111827',
            border: '2px solid #3b82f6',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '24px'
          }}>
            <h3 style={{
              color: '#3b82f6',
              fontSize: '14px',
              marginBottom: '8px',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              Your Enrollment Code
            </h3>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px'
            }}>
              <code style={{
                color: 'white',
                fontSize: '24px',
                fontWeight: 'bold',
                letterSpacing: '2px',
                fontFamily: 'monospace'
              }}>
                {enrollmentCode}
              </code>
              <button
                onClick={handleCopyCode}
                style={{
                  background: copied ? '#10b981' : '#374151',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  display: 'flex',
                  alignItems: 'center'
                }}
                title="Copy code"
              >
                {copied ? <CheckCircle size={18} color="white" /> : <Copy size={18} color="white" />}
              </button>
            </div>
            <p style={{
              color: '#9ca3af',
              fontSize: '12px',
              marginTop: '8px'
            }}>
              Use this code to access virtual labs
            </p>
          </div>
        )}

        <div style={{
          backgroundColor: '#111827',
          border: '1px solid #374151',
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '24px'
        }}>
          <h3 style={{
            color: 'white',
            fontSize: '18px',
            marginBottom: '12px'
          }}>
            What's Next?
          </h3>
          <ul style={{
            color: '#9ca3af',
            textAlign: 'left',
            lineHeight: '1.6',
            paddingLeft: '20px'
          }}>
            <li>Access your course materials in the Student Portal</li>
            <li>Start with the first module and progress at your own pace</li>
            <li>Join the community discussion for this course</li>
            <li>Track your progress and earn certificates</li>
          </ul>
        </div>

        <button
          style={{
            backgroundColor: '#06b6d4',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 32px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            margin: '0 auto'
          }}
          onClick={handleGoToPortal}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#0891b2'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#06b6d4'}
        >
          Go to Student Portal
          <Target size={16} />
        </button>
      </div>

      <style jsx>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.8;
          }
        }
      `}</style>
    </div>
  );
};

export default EnrollmentSuccessModal;
